import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { FileText, GitCompareArrows, Sparkles } from 'lucide-react';

export type PanelTab = 'ask' | 'summary' | 'what-changed';

export const panelTab = (value: string | null): PanelTab => (value === 'summary' || value === 'what-changed' ? value : 'ask');

type Props = { value: PanelTab; changes: number; onChange: (tab: PanelTab) => void };

export function ReportPanelTabs({ value, changes, onChange }: Props) {
  return (
    <Tabs value={value} onChange={(_, v: PanelTab) => { onChange(v); }} sx={{ px: 1.5, minHeight: 44, flexShrink: 0, '& .MuiTab-root': tabSx }}>
      <Tab value="ask" icon={<Sparkles size={14} />} iconPosition="start" label="Ask" />
      <Tab value="summary" icon={<FileText size={14} />} iconPosition="start" label="Summary" />
      <Tab
        value="what-changed"
        icon={<GitCompareArrows size={14} />}
        iconPosition="start"
        label={
          <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
            What changed
            {changes > 0 ? <Box component="span" sx={badgeSx}>{changes}</Box> : null}
          </Box>
        }
      />
    </Tabs>
  );
}

const tabSx = { minHeight: 44, fontSize: '0.8125rem', gap: 0.5, px: 1, '& svg': { mb: '0 !important' } } as const;

const badgeSx = {
  minWidth: 18,
  height: 18,
  px: 0.5,
  borderRadius: 9,
  display: 'inline-grid',
  placeItems: 'center',
  fontSize: '0.6875rem',
  fontWeight: 600,
  bgcolor: 'surface.accentSoft',
  color: 'primary.main',
} as const;
